import { useEffect, useState } from 'react'
import { BatteryCharging, Signal, Wifi } from 'lucide-react'
import styled from 'styled-components'
import { Box, Flex, Text } from 'ui'
import { previewTokens } from './styles'

const timeFormatter = new Intl.DateTimeFormat(undefined, {
  hour: 'numeric',
  minute: '2-digit',
})

const ChromeLayer = styled(Box)`
  position: absolute;
  inset: 0;
  z-index: 20;
  pointer-events: none;
  color: ${previewTokens.colors.text};
  margin-top: 14px;
`

const StatusTime = styled(Text)`
  position: absolute;
  top: 8px;
  left: 24px;
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
`

const StatusIcons = styled(Flex)`
  position: absolute;
  top: 9px;
  right: 18px;
  align-items: center;
  gap: 4px;
`

export const MobileChrome = () => {
  const [currentTime, setCurrentTime] = useState(new Date())

  useEffect(() => {
    let timeoutId: number

    const scheduleNextMinute = () => {
      const now = new Date()
      const delay = (60 - now.getSeconds()) * 1000 - now.getMilliseconds()

      timeoutId = window.setTimeout(() => {
        setCurrentTime(new Date())
        scheduleNextMinute()
      }, delay)
    }

    scheduleNextMinute()

    return () => {
      window.clearTimeout(timeoutId)
    }
  }, [])

  return (
    <ChromeLayer aria-hidden="true">
      <StatusTime>{timeFormatter.format(currentTime)}</StatusTime>
      <StatusIcons>
        <Signal size={13} strokeWidth={2.5} />
        <Wifi size={14} strokeWidth={2.5} />
        <BatteryCharging size={17} strokeWidth={2.5} />
      </StatusIcons>
    </ChromeLayer>
  )
}
